﻿import { Output } from "@models/configurators/outputs/output";
import { FileOutput } from "@models/configurators/outputs/file-output";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IImageOutput, IOutput } from "@models/entity-models";
import { eOutputType } from "@models/enums";
import { Kbo, KboOutput } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutput(CToken.ImageOutput, eOutputType.image)
export class ImageOutput extends FileOutput implements IImageOutput {
    constructor(kom: KbObjectManager, args?: IOutput) {
        super(kom, args);
    }
}
